export function isJSModuleWithDefaultExport(module) {
  try {
    // This should be replaced with Object.hasOwn once it is more widely supported
    return Object.prototype.hasOwnProperty.call(module, 'default');
  } catch (_) {
    // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
    return false;
  }
}